/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TreemapExportXlsxRequest } from '../models/TreemapExportXlsxRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TradeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Trade Search
     * @param exporter Exporter country code; omit for all exporters
     * @param importer Importer country code; omit for all importers
     * @param year Year; omit for all years
     * @param hsCodes Comma-separated HS codes; empty for all
     * @returns any Successful Response
     * @throws ApiError
     */
    public tradeSearchApiV1TradeSearchGet(
        exporter?: (number | null),
        importer?: (number | null),
        year?: (number | null),
        hsCodes: string = '',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/search',
            query: {
                'exporter': exporter,
                'importer': importer,
                'year': year,
                'hs_codes': hsCodes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Trade Years
     * @returns any Successful Response
     * @throws ApiError
     */
    public listTradeYearsApiV1TradeYearsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/years',
        });
    }
    /**
     * Country World Trade
     * @param countryCode Country code
     * @param year
     * @param hsCodes Comma-separated HS codes; empty for all
     * @returns any Successful Response
     * @throws ApiError
     */
    public countryWorldTradeApiV1TradeCountryWorldGet(
        countryCode: number,
        year: number,
        hsCodes: string = '',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/country-world',
            query: {
                'country_code': countryCode,
                'year': year,
                'hs_codes': hsCodes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Country World Trade Summary
     * @param countryCode Country code
     * @param year
     * @param hsCodes Comma-separated HS codes; empty for all
     * @returns any Successful Response
     * @throws ApiError
     */
    public countryWorldTradeSummaryApiV1TradeCountryWorldSummaryGet(
        countryCode: number,
        year: number,
        hsCodes: string = '',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/country-world/summary',
            query: {
                'country_code': countryCode,
                'year': year,
                'hs_codes': hsCodes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Country World Hs Codes
     * @param countryCode
     * @param year
     * @returns any Successful Response
     * @throws ApiError
     */
    public countryWorldHsCodesApiV1TradeCountryWorldHsCodesGet(
        countryCode: number,
        year: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/country-world/hs-codes',
            query: {
                'country_code': countryCode,
                'year': year,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Rca By Hs
     * @param countryCode Country code i
     * @param year
     * @param hsCodes Comma-separated HS codes to limit; empty for all
     * @returns any Successful Response
     * @throws ApiError
     */
    public rcaByHsApiV1TradeRcaGet(
        countryCode: number,
        year: number,
        hsCodes: string = '',
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/trade/rca',
            query: {
                'country_code': countryCode,
                'year': year,
                'hs_codes': hsCodes,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export treemap data (HS6) to XLSX with legend + data sheets
     * Export the treemap's underlying HS6 data as an XLSX file with two sheets:
     * - legend: selected value chain, country, year
     * - data: hs6 code, description, hs4, hs2, exports, imports (USD thousands)
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public treemapExportXlsxApiV1TradeTreemapExportXlsxPost(
        requestBody: TreemapExportXlsxRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/trade/treemap-export-xlsx',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
